import React, {useContext, useEffect, useState, Fragment} from "react";
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import {BaseUrl} from "../../../contexts/baseUrl/baseUrl";
import Layout from "../../../components/sales/layout/layout";
import Images from 'assets/images/imageData';
import { Link } from 'react-router-dom';

const WalletApproval = ({
    history,
    match,
    requestApprovalList,
    approvalListDetails = [],
    documentUploadUrl,
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const {baseUrl} = useContext(BaseUrl);
    const [listData, setListData] = useState();
    const [isModal, setIsModal] = useState(false);
    // const [actionData, setActionData] = useState();
    // const [isSuccessModel, setIsSuccessModel] = useState(false);
    // const [remark, setRemark] = useState("");
    // const [closed, setClosed] = useState(false);
    // const [image, setImage] = useState("");
    // const [statusVal, setStatusVal] = useState("");
    const role = JSON.parse(localStorage.getItem('roles'));
    const [roleId, setRoleId] = useState('');

    useEffect(() => {
        (async () => {
            role && setRoleId(role[0].pivot.role_id);
          })();
    },[role]);

    const handleModalHide = () => {
        setIsModal(false);
        window.location.reload();
    }

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await requestApprovalList(1)
            setIsLoading(false)
        })()
    }, []);

    const successIconBox = (text, func) => {
        return (
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="" />
            </div>
            <h5>{text}</h5>
            <Link to="/dashboard/wallet/approval-listing" onClick={func} className="btn btn-transparent">
              {localization.returnToList}{' '}
              <img src={Images?.ArrowRight} alt="" />
            </Link>
          </div>
        );
      };

    const headers = [
        'Requested By',
        'Wallet Type',
        'Category',
        'Subcategory',
        // 'Partner Name',
        'Amount',
        'Status',
        'Created At',
        'Action'
    ];

    const headersByRoles = [
        'Wallet Type',
        'Category',
        'Subcategory',
        'Wallet Balance',
        'Hold Amount',
        'Amount',
        'Final Amount',
        'Status',
        'Created At',
        'Action'
    ];

    const onPageChange = async (val) => {
        setIsLoading(true);
        await requestApprovalList(val.selected + 1);
        setIsLoading(false);
    };

    //console.log(JSON.stringify(approvalListDetails))
    useEffect(() => {
        if (approvalListDetails &&
            approvalListDetails?.data !== undefined && approvalListDetails?.data.length > 0) {
            let tableData = [];
            tableData = ['id', 'created_by','wallet_type', 'category_name', 'subcategory_name', 'amount', 'status' ,'created_at'];
            if(parseInt(roleId) === 47 || parseInt(roleId) === 26 || parseInt(roleId) === 13 || parseInt(roleId) === 49){
                tableData = ['id', 'created_by', 'wallet_type', 'category_name', 'subcategory_name', 'amount', 'hold_balance', 'final_balance', 'status' ,'created_at'];
            }

            const data = approvalListDetails?.data.map((element) =>
                Object.assign(
                    ...tableData.map((key) => (
                        key === 'status' && parseInt(element['status']) === 1 ? {[key]: 'Manager Pending'} :
                            key === 'status' && parseInt(element['status']) === 2 ? {[key]: 'Finance Pending'} :
                                key === 'status' && parseInt(element['status']) === 3 ? {[key]: 'Manager Rejected'} :
                                    key === 'status' && parseInt(element['status']) === 4 ? {[key]: 'Finance Approved'} :
                                        key === 'status' && parseInt(element['status']) === 5 ? {[key]: 'Finance Rejected'} :
                                            {[key]: element[key]}
                    )),
                    {
                        Action: [
                            {name:'View', link:`${baseUrl}/wallet/approval-wallet-details`},
                          ]
                    },
                )
            )
            if (data) {
                data && setListData(data);
            }
            setPageCount(Math.ceil(approvalListDetails.total / approvalListDetails.per_page));
        }
    }, [approvalListDetails])

    return (
        <>
            <Layout
                title={localization.approvalList}
                isLoading={isLoading}
                isGoback={true}
            >
            <TableSection
                data={listData}
                isId={false}
                isMngId={false}
                headers={(parseInt(roleId) === 47 || parseInt(roleId) === 26 || parseInt(roleId) === 13 || parseInt(roleId) === 49) ? headersByRoles : headers}
                pageCount={pageCount}
                onPageChange={onPageChange}
                detailList={approvalListDetails?.data && approvalListDetails?.data}
                srNo={approvalListDetails?.from}
            />
            </Layout>
        </>
    )
}

export default WalletApproval

